var map = {
	"./campaigns/ActiveLifestyleCarrefour": 76653,
	"./campaigns/ActiveLifestyleCarrefour.js": 76653,
	"./campaigns/ActiveLifestyleCora": 70595,
	"./campaigns/ActiveLifestyleCora.js": 70595,
	"./campaigns/ActiveLifestyleMega": 46662,
	"./campaigns/ActiveLifestyleMega.js": 46662,
	"./campaigns/AjaxAxion2023": 3615,
	"./campaigns/AjaxAxion2023.js": 3615,
	"./campaigns/Auchan2022": 72445,
	"./campaigns/Auchan2022.js": 72445,
	"./campaigns/AutumnCleaning2022": 6342,
	"./campaigns/AutumnCleaning2022.js": 6342,
	"./campaigns/Autumncleaning2023": 51269,
	"./campaigns/Autumncleaning2023.js": 51269,
	"./campaigns/Carrefour2022": 85852,
	"./campaigns/Carrefour2022.js": 85852,
	"./campaigns/CarrefourAniversar2024": 60367,
	"./campaigns/CarrefourAniversar2024.js": 60367,
	"./campaigns/CarrefourAniversar2025": 26008,
	"./campaigns/CarrefourAniversar2025.js": 26008,
	"./campaigns/ColgateAugust2022": 71887,
	"./campaigns/ColgateAugust2022.js": 71887,
	"./campaigns/ColgateCarrefour21Ani": 7500,
	"./campaigns/ColgateCarrefour21Ani.js": 7500,
	"./campaigns/ColgateCharcoal": 51299,
	"./campaigns/ColgateCharcoal.js": 51299,
	"./campaigns/ColgateElixirCarrefour2022": 9414,
	"./campaigns/ColgateElixirCarrefour2022.js": 9414,
	"./campaigns/ColgateEquityCarrefourJan2022": 465,
	"./campaigns/ColgateEquityCarrefourJan2022.js": 465,
	"./campaigns/ColgateIT": 87661,
	"./campaigns/ColgateIT.js": 87661,
	"./campaigns/ColgateKaufland2025": 34033,
	"./campaigns/ColgateKaufland2025.js": 34033,
	"./campaigns/ColgateLLDP2025": 86835,
	"./campaigns/ColgateLLDP2025.js": 86835,
	"./campaigns/ColgateLidl2025": 4572,
	"./campaigns/ColgateLidl2025.js": 4572,
	"./campaigns/ColgateLidl2026": 68997,
	"./campaigns/ColgateLidl2026.js": 68997,
	"./campaigns/ColgateMax2023": 56781,
	"./campaigns/ColgateMax2023.js": 56781,
	"./campaigns/ColgateMaxAuchan2023": 49135,
	"./campaigns/ColgateMaxAuchan2023.js": 49135,
	"./campaigns/ColgateOHM2024": 67592,
	"./campaigns/ColgateOHM2024.js": 67592,
	"./campaigns/ColgateOHMLDP2024": 64538,
	"./campaigns/ColgateOHMLDP2024.js": 64538,
	"./campaigns/ColgatePalmolive2023": 84612,
	"./campaigns/ColgatePalmolive2023.js": 84612,
	"./campaigns/ColgatePalmoliveLidl2026": 22124,
	"./campaigns/ColgatePalmoliveLidl2026.js": 22124,
	"./campaigns/ColgateSeptember2023": 11180,
	"./campaigns/ColgateSeptember2023.js": 11180,
	"./campaigns/ColgateSummer2023": 89000,
	"./campaigns/ColgateSummer2023.js": 89000,
	"./campaigns/ColgateSummerKaufland2023": 97186,
	"./campaigns/ColgateSummerKaufland2023.js": 97186,
	"./campaigns/ColgateTotal2023": 94821,
	"./campaigns/ColgateTotal2023.js": 94821,
	"./campaigns/ColgateTotal2024": 12144,
	"./campaigns/ColgateTotal2024.js": 12144,
	"./campaigns/ColgateTotal2025": 19015,
	"./campaigns/ColgateTotal2025.js": 19015,
	"./campaigns/ColgateTotal2026": 91994,
	"./campaigns/ColgateTotal2026.js": 91994,
	"./campaigns/ColgateTotalActivePrevention2025": 51573,
	"./campaigns/ColgateTotalActivePrevention2025.js": 51573,
	"./campaigns/ColgateTotalAutumn2026": 43044,
	"./campaigns/ColgateTotalAutumn2026.js": 43044,
	"./campaigns/ColgateTotalCarrefour2022": 80535,
	"./campaigns/ColgateTotalCarrefour2022.js": 80535,
	"./campaigns/ColgateTotalDM2022": 18573,
	"./campaigns/ColgateTotalDM2022.js": 18573,
	"./campaigns/ColgateTotalFraud2024": 61984,
	"./campaigns/ColgateTotalFraud2024.js": 61984,
	"./campaigns/ColgateTotalMegaImage2022": 67223,
	"./campaigns/ColgateTotalMegaImage2022.js": 67223,
	"./campaigns/ColgateUltra2023": 58477,
	"./campaigns/ColgateUltra2023.js": 58477,
	"./campaigns/ColgateWhite2025": 51964,
	"./campaigns/ColgateWhite2025.js": 51964,
	"./campaigns/ColgateWhiteMoneyBack2024": 9968,
	"./campaigns/ColgateWhiteMoneyBack2024.js": 9968,
	"./campaigns/ColgateWhiteMoneyBack2025": 34119,
	"./campaigns/ColgateWhiteMoneyBack2025.js": 34119,
	"./campaigns/ColgateWhiteMoneyBack2026": 30394,
	"./campaigns/ColgateWhiteMoneyBack2026.js": 30394,
	"./campaigns/ColgateWhitening2023": 95320,
	"./campaigns/ColgateWhitening2023.js": 95320,
	"./campaigns/ColgateWhitening2024": 87757,
	"./campaigns/ColgateWhitening2024.js": 87757,
	"./campaigns/ColgateWhiteningAuchan2022": 38841,
	"./campaigns/ColgateWhiteningAuchan2022.js": 38841,
	"./campaigns/ColgateWhiteningCarrefour2022": 74320,
	"./campaigns/ColgateWhiteningCarrefour2022.js": 74320,
	"./campaigns/ColgateWhiteningSelgros2024": 46450,
	"./campaigns/ColgateWhiteningSelgros2024.js": 46450,
	"./campaigns/ColgateWomenDay2024": 60056,
	"./campaigns/ColgateWomenDay2024.js": 60056,
	"./campaigns/ColgateWomenDay2025": 6863,
	"./campaigns/ColgateWomenDay2025.js": 6863,
	"./campaigns/ColgateWomenDay2026": 32674,
	"./campaigns/ColgateWomenDay2026.js": 32674,
	"./campaigns/Elmex-MB2023": 38887,
	"./campaigns/Elmex-MB2023.js": 38887,
	"./campaigns/Elmex2023": 34021,
	"./campaigns/Elmex2023.js": 34021,
	"./campaigns/ElmexAuchanFeb2022": 6103,
	"./campaigns/ElmexAuchanFeb2022.js": 6103,
	"./campaigns/ElmexAugust2022": 15423,
	"./campaigns/ElmexAugust2022.js": 15423,
	"./campaigns/ElmexCarrefourFeb2022": 30046,
	"./campaigns/ElmexCarrefourFeb2022.js": 30046,
	"./campaigns/ElmexCarrefourJuly2022": 2173,
	"./campaigns/ElmexCarrefourJuly2022.js": 2173,
	"./campaigns/ElmexIT2023": 75332,
	"./campaigns/ElmexIT2023.js": 75332,
	"./campaigns/ElmexMegaFeb2022": 81663,
	"./campaigns/ElmexMegaFeb2022.js": 81663,
	"./campaigns/ElmexMoneyBack2024": 47841,
	"./campaigns/ElmexMoneyBack2024.js": 47841,
	"./campaigns/ElmexMoneyBack2025": 28114,
	"./campaigns/ElmexMoneyBack2025.js": 28114,
	"./campaigns/IngrijirePersonalaKaufland2025": 74976,
	"./campaigns/IngrijirePersonalaKaufland2025.js": 74976,
	"./campaigns/Ladyspeedstick2023": 54029,
	"./campaigns/Ladyspeedstick2023.js": 54029,
	"./campaigns/LidlBeauty2025": 14569,
	"./campaigns/LidlBeauty2025.js": 14569,
	"./campaigns/MegaImage2022": 99720,
	"./campaigns/MegaImage2022.js": 99720,
	"./campaigns/Moneyback2022": 24480,
	"./campaigns/Moneyback2022.js": 24480,
	"./campaigns/Palmolive2023": 14707,
	"./campaigns/Palmolive2023.js": 14707,
	"./campaigns/PalmoliveCarrefourJune2022": 98161,
	"./campaigns/PalmoliveCarrefourJune2022.js": 98161,
	"./campaigns/PalmoliveChristmas2024": 37236,
	"./campaigns/PalmoliveChristmas2024.js": 37236,
	"./campaigns/PalmoliveExperentials2023": 9825,
	"./campaigns/PalmoliveExperentials2023.js": 9825,
	"./campaigns/PalmoliveLifestyle2024": 15491,
	"./campaigns/PalmoliveLifestyle2024.js": 15491,
	"./campaigns/PalmoliveSmoothies2022": 2723,
	"./campaigns/PalmoliveSmoothies2022.js": 2723,
	"./campaigns/PalmoliveSummer2023": 82430,
	"./campaigns/PalmoliveSummer2023.js": 82430,
	"./campaigns/Protex2023": 18380,
	"./campaigns/Protex2023.js": 18380,
	"./campaigns/Protex2024": 53913,
	"./campaigns/Protex2024.js": 53913,
	"./campaigns/ProtexCarrefour": 80998,
	"./campaigns/ProtexCarrefour.js": 80998,
	"./campaigns/ProtexCarrefourJan2022": 92055,
	"./campaigns/ProtexCarrefourJan2022.js": 92055,
	"./campaigns/ProtexCharcoalCarrefour2022": 93737,
	"./campaigns/ProtexCharcoalCarrefour2022.js": 93737,
	"./campaigns/ProtexCharcoalCora2022": 48891,
	"./campaigns/ProtexCharcoalCora2022.js": 48891,
	"./campaigns/ProtexCharcoalMega2022": 10882,
	"./campaigns/ProtexCharcoalMega2022.js": 10882,
	"./campaigns/ProtexHealthProtection2023": 16185,
	"./campaigns/ProtexHealthProtection2023.js": 16185,
	"./campaigns/ProtexSummerCarrefour2022": 58255,
	"./campaigns/ProtexSummerCarrefour2022.js": 58255,
	"./campaigns/ProtexSummerRomania": 57269,
	"./campaigns/ProtexSummerRomania.js": 57269,
	"./campaigns/Protexcashback2025": 69818,
	"./campaigns/Protexcashback2025.js": 69818,
	"./campaigns/SpringCleaning2025": 16720,
	"./campaigns/SpringCleaning2025.js": 16720,
	"./campaigns/SpringCleaningCarrefour2022": 12418,
	"./campaigns/SpringCleaningCarrefour2022.js": 12418,
	"./campaigns/SpringCleaningCora2022": 81590,
	"./campaigns/SpringCleaningCora2022.js": 81590,
	"./campaigns/SpringCleaningMega2022": 82195,
	"./campaigns/SpringCleaningMega2022.js": 82195,
	"./campaigns/Springcleaning2024": 86567,
	"./campaigns/Springcleaning2024.js": 86567,
	"./campaigns/SummerExperience2024": 51032,
	"./campaigns/SummerExperience2024.js": 51032,
	"./campaigns/SummerJoy2025": 81147,
	"./campaigns/SummerJoy2025.js": 81147,
	"./campaigns/SummerJoy2026": 61310,
	"./campaigns/SummerJoy2026.js": 61310,
	"./campaigns/WomenDay2024": 89369,
	"./campaigns/WomenDay2024.js": 89369,
	"./campaigns/WomenDay2025": 19114,
	"./campaigns/WomenDay2025.js": 19114,
	"./campaigns/WomenDay2026": 96375,
	"./campaigns/WomenDay2026.js": 96375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95335;